<script lang="ts">
    import Gallery from "./Gallery.svelte";
    import { loadItems } from "../utils";

    const fetchImage: Promise<any> = (async () => {
        return loadItems("e30b2bf0-ae23-11ea-827d-a91f136d806f").then(
            (resp) => {
                return JSON.parse(resp).data.viewGallery.content;
            }
        );
    })();
</script>

<div class="monthly-images">
    {#await fetchImage}
        <p>ladataan</p>
    {:then data}
        <Gallery content={decodeURI(data)}/>
    {:catch error}
        <p>{error}</p>
    {/await}
</div>